// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__tfCII","balanceDisclaimer":"posDashboard_balanceDisclaimer__3RmWc"};